/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 10 = Started
 *
 * 20 = Collected
 *
 * 30 = DeliveredToTheBranch
 *
 * 40 = QualityCheck
 *
 * 50 = CollectedFromBranch
 *
 * 60 = ReturnedToCustomer
 *
 * 70 = ReturnedToBranch
 */
export enum CollectionDeliveryStatuses {
  Started = 10,
  Collected = 20,
  DeliveredToTheBranch = 30,
  QualityCheck = 40,
  CollectedFromBranch = 50,
  ReturnedToCustomer = 60,
  ReturnedToBranch = 70,
}
